export default {
	documents: {
		en: 'Documents',
		ge: 'დოკუმენტები',
		de: 'Dokumente',
		ru: 'Документы',
		cn: 'Documents',
		pt: 'Documentos'
	},

	invoice: {
		en: 'Invoice',
		ge: 'ინვოისი',
		de: 'Rechnung',
		ru: 'Счет',
		cn: 'Invoice',
		pt: 'Fatura'
	},

	invoices: {
		en: 'Invoices',
		ge: 'ინვოისები',
		de: 'Rechnungen',
		ru: 'Счета',
		cn: 'Invoices',
		pt: 'Faturas'
	},

	invoice_id: {
		en: 'Invoice Number',
		ge: 'ინვოისის ნომერი',
		de: 'Rechnungsnummer',
		ru: 'Номер счета',
		cn: 'Invoice Number',
		pt: 'Número da fatura'
	},

	invoice_date: {
		en: 'Date',
		ge: 'თარიღი',
		de: 'Datum',
		ru: 'Дата',
		cn: 'Date',
		pt: 'Data'
	},

	invoice_total_excl_tax: {
		en: 'Total excl. tax',
		ge: 'სულ გამოკლ. გადასახადი',
		de: 'Gesamtbetrag ohne Steuern',
		ru: 'Сумма без налога',
		cn: 'Total excl. tax',
		pt: 'Total sem impostos'
	},

	invoice_status: {
		en: 'Status',
		ge: 'სტატუსი',
		de: 'Status',
		ru: 'Статус',
		cn: 'Status',
		pt: 'Status'
	},

	invoice_status_pending: {
		en: 'not paid',
		ge: 'არ არის გადახდილი',
		de: 'nicht bezahlt',
		ru: 'не оплачен',
		cn: 'not paid',
		pt: 'não pago'
	},

	invoice_status_paid: {
		en: 'paid',
		ge: 'გადახდილი',
		de: 'bezahlt',
		ru: 'оплачен',
		cn: 'paid',
		pt: 'pago'
	},

	invoice_status_canceled: {
		en: 'canceled',
		ge: 'გაუქმდა',
		de: 'storniert',
		ru: 'отменен',
		cn: 'canceled',
		pt: 'cancelado'
	},

	ad_time_and_money_per_device: {
		en: 'Ad time and money per device',
		ge: 'Ad time and money per device', // TODO: translate
		de: 'Ad time and money per device', // TODO: translate
		ru: 'Рекламное время и деньги для каждого устройства',
		cn: 'Ad time and money per device', // TODO: translate
		pt: 'Ad time and money per device' // TODO: translate
	},

	id: {
		en: 'ID',
		ge: 'ID',
		de: 'ID',
		ru: 'ID',
		cn: 'ID',
		pt: 'ID'
	},

	time: {
		en: 'Time',
		ge: 'დრო',
		de: 'Zeit',
		ru: 'Время',
		cn: 'Time',
		pt: 'Tempo'
	},

	start_date: {
		en: 'Start date',
		ge: 'Start date', // TODO: translate
		de: 'Start date', // TODO: translate
		ru: 'С',
		cn: 'Start date', // TODO: translate
		pt: 'Start date' // TODO: translate
	},

	end_date: {
		en: 'End date',
		ge: 'End date', // TODO: translate
		de: 'End date', // TODO: translate
		ru: 'По',
		cn: 'End date', // TODO: translate
		pt: 'End date' // TODO: translate
	},

	device_id: {
		en: 'Device ID',
		ge: 'Device ID', // TODO: translate
		de: 'Device ID', // TODO: translate
		ru: 'ID устройства',
		cn: 'Device ID', // TODO: translate
		pt: 'Device ID' // TODO: translate
	},

	active_time: {
		en: 'Active time',
		ge: 'Active time', // TODO: translate
		de: 'Active time', // TODO: translate
		ru: 'Активное время',
		cn: 'Active time', // TODO: translate
		pt: 'Active time' // TODO: translate
	},

	earnings: {
		en: 'Earnings',
		ge: 'Earnings', // TODO: translate
		de: 'Earnings', // TODO: translate
		ru: 'Прибыль',
		cn: 'Earnings', // TODO: translate
		pt: 'Earnings' // TODO: translate
	},
};
